export default "__VITE_ASSET__827ad916__"